import artifact from '$houdini/artifacts/UpdateSettingDefaultValue'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateSettingDefaultValueStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
